import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';


@Injectable()
export class FormValidationHelper {
  validate(form: AbstractControl, formErrors: any) {
    if (!form) {
      return;
    }

    for (const field in formErrors) {
      if (!formErrors.hasOwnProperty(field)) {
        continue;
      }
      const control = form.get(field);

      if (control instanceof FormGroup) {
        this.validate(control, formErrors[field]);
      }

      if (control && control.dirty && !control.valid) {
        for (const key in control.errors) {
          if (!control.errors.hasOwnProperty(key)) {
            continue;
          }
          const errorMessage = this.getErrorMessage(`${field}.${key}`);
          if (key === "cfValid") {
            formErrors[field][key].push(errorMessage);
          } else {
            formErrors[field].push(errorMessage);
          }
        }
      }
    }
  }

  getErrorMessage(key: string) {
    console.log("KEY", key);
    switch (key) {
      case `username.required`:
        return `Email mancante.`;
      case 'username.email':
        return 'Indirizzo email non valido.';
      case 'password.required':
        return 'Password mancante.';
      case 'password.minlength':
        return 'La password deve contenere almeno 6 caratteri.';
      case 'verifyPassword.required':
        return 'Password mancante.';
      case 'verifyPassword.minlength':
        return 'La password deve contenere almeno 6 caratteri.';
      case 'client.required':
        return 'Cliente mancante.';
      case 'email.required':
        return 'Email mancante.';
      case 'email.email':
        return 'Indirizzo email non valido.';
      case 'email.pattern':
        return 'Indirizzo email non valido.';
      case 'phoneNr.required':
        return 'Numero di telefono mancante.';
      case 'phoneNr.pattern':
        return 'Numero di telefono non valido.';
      case 'companyName.required':
        return 'Ragione Sociale mancante.';
      case 'name.required':
        return 'Nome mancante.';
      case 'surname.required':
        return 'Cognome mancante.';
      case 'address.cfValid':
        return 'Codice Fiscale Non Valido.';
      case 'fiscalCode.required':
        return 'Codice Fiscale mancante.';
      case 'fiscalCode.pattern':
        return 'Codice Fiscale errato.';
      case 'cityOfBirth.required':
        return 'Città mancante.';
      case 'provinceOfBirth.required':
        return 'Provincia mancante.';
      case 'provinceOfBirth.pattern':
        return 'Provincia errata, 2 Lettere.';
      case 'vat.required':
        return 'Partita IVA mancante.';
      case 'vat.pattern':
        return 'Partita IVA errata.';
      case 'address.required':
        return 'Indirizzo mancante.';
      case 'city.required':
        return 'Città mancante.';
      case 'province.required':
        return 'Provincia mancante.';
      case 'province.pattern':
        return 'Provincia errata, 2 Lettere.';
      case 'zipCode.required':
        return 'CAP mancante.';
      case 'zipCode.pattern':
        return 'CAP errato, 5 cifre.';
      case 'country.required':
        return 'Stato mancante.';
      case 'country.pattern':
        return 'Stato errato, 2 Lettere.';
      case 'sdiCode.required':
        return 'codice SDI mancante.';
      case 'sdiCode.pattern':
        return 'codice SDI errato, 7 caratteri.';
      case 'pec.pattern':
        return 'PEC errata';
      case 'shipmentRefName.required':
        return 'Nome mancante.';
      case 'shipmentAddress.required':
        return 'Indirizzo mancante.';
      case 'shipmentCity.required':
        return 'Città mancante.';
      case 'shipmentProvince.required':
        return 'Provincia mancante.';
      case 'shipmentProvince.pattern':
        return 'Provincia errata, 2 Lettere.';
      case 'shipmentZipCode.required':
        return 'CAP mancante.';
      case 'shipmentZipCode.pattern':
        return 'CAP errato, 5 cifre.';
      case 'shipmentCountry.required':
        return 'Stato mancante.';
      case 'shipmentCountry.pattern':
        return 'Stato errato, 2 Lettere.';
      case 'parcelWeight.required':
        return 'Pesso mancante.';
      case 'parcelWeight.pattern':
        return 'Formato di peso non valido.';
      case 'parcelValue.required':
        return 'Valore mancante.';
      case 'parcelValue.pattern':
        return 'Formato del valore non valido.';
      default:
        return "Errore, controlla i campi inseriti"
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/util/form-validation.helper.ts